import { usePayment } from '@melio/platform-api';
import { forwardRef } from '@melio/platform-utils';

import { PaymentScheduledScreen } from './screens';

export type PaymentScheduledActivityProps = {
  onBack?: VoidFunction;
  onClose?: VoidFunction;
  paymentId?: string;
};

export const PaymentScheduledActivity = forwardRef<PaymentScheduledActivityProps>(
  ({ onBack, paymentId, ...props }, ref) => {
    const { data: payment, isLoading: isPaymentLoading } = usePayment({ id: paymentId });
    return <PaymentScheduledScreen isLoading={isPaymentLoading} payment={payment} {...props} ref={ref} />;
  }
);
PaymentScheduledActivity.displayName = 'PaymentScheduledActivity';
